import {container_content, colors} from '@xpertdox_js/xdstyle'

export default {
  container: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row'
  },
  panel: {
    ...container_content,
    background: colors.background,
    boxSizing: 'border-box',
  },
  manualTrialDates: {
    display: 'flex',
    flexDirection: 'row',
    fontSize: '12px',
    justifyContent: 'space-between'
  },
  disclaimer: {
    color: '#d05755',
    margin: '5px 2px',
    fontSize: '11px'
  },
  svg: {
    height:'15px',
    width: '15px',
    cursor: 'pointer',
    margin: '1em 0'
  },
  addTrialButton: {
    marginTop: '1px',
    padding: '5px 12px',
    fontWeight: 'bold',
    fontSize: '1.42rem',
    color: colors.xdDarkBlue,
    fill: colors.xdDarkBlue,
    // background: colors.xdFadedBlue,
    background: '#EAECF0',
    borderRadius: '200px',
    transition: 'background .18s, color .18s, fill .18s, box-shadow .32s',
    boxShadow: 'none',
    verticalAlign: 'top',
    float: 'left',
  },
  addTrialHovBtn : {
    background: '#fff',
    boxShadow: '0 2px 2px rgba(0,0,0,0.1)',
    color: colors.xdHighlight,
    fill: colors.xdHighlight,
  },
  addTrialBtnIcon: {
    display: 'block',
    float: 'left',
    marginRight: '8px',
    width: '1.8rem',
    height: '1.8rem'
  },
  addTrialBtnText: {
    display: 'inline-block',
  },
  searchBar: {
    padding: '5px 22px 5px 14px',
    width: '258px',
    borderRadius: '150px'
  }
}
